import { createContext } from "react";

import { IProductAddOptions } from "@faire/retailer/features/ProductAdd/ProductAddOptions";

interface IQuickAddInvoiceContext {
  isInvoice: boolean;
  productAddOptions?: IProductAddOptions;
}

export const QuickAddInvoiceContext = createContext<IQuickAddInvoiceContext>({
  isInvoice: false,
});
